const VERSION = 6.4

export default VERSION



// WEBPACK FOOTER //
// ./src/constants/version.js